<template>
  <div class="loading-page">
    <a-spin size="large" text="SSO load..." />
  </div>
</template>

<script setup lang="ts">
import { useSsoStore } from "@/store/modules/sso"

const ssoStore = useSsoStore()

ssoStore.gotoOssLogin()
</script>

<style scoped>
.loading-page {
  position: fixed;
  inset: 0;
  top: 50%;
  left: 50%;
  z-index: 3000;
  width: 36px;
  height: 36px;
  transform: translate(-50%, -50%);
}

:deep(.ant-spin) {
  position: static !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
}

:deep(.ant-spin .ant-spin-mask) {
  background: #fff !important;
  opacity: 1 !important;
}
</style>
